import React, {useState} from "react";
import { GET_LIST, SimpleForm, Create, Toolbar, SaveButton } from "react-admin";
import { Card, Button, CardContent } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import moment from "moment";
import styled from "styled-components";
import moment_tz from 'moment-timezone';
import {
  map,
  curry,
  range,
  filter,
  compose,
  isEmpty,
  prop,
  isNil
} from "ramda";
import LinearProgress from "@material-ui/core/LinearProgress";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import CustomDatePicker from "./customDatePicker";
import Select from "@material-ui/core/Select";
import { Link } from "react-router-dom";
import { parse } from "query-string";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
// import ReactExport from "react-export-excel";

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

import ReactExport from 'react-data-export';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const StyledTableCell = styled(TableCell)`
  white-space: nowrap;
`;

const styles = {
  container: {
    marginLeft: "0em",
    textAlign: "center",
  },
  rightAlignedCell: { textAlign: "right" },
  leftAlignedCell: { textAlign: "left" },
  boldCell: { fontWeight: "bold" },
};

let dataSet1 = [];

const StartForm = styled.form({
  margin: "30px",
  display: "flex",
  flexDirection: "column",
  width: "30%",
//   height: "29rem",
  justifyContent: "space-between"
});

const useStyles = styled.div({
    backgroundColor: "transparent"
});
class ReportDetails extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        isLoading: true,
        numberOfMonths: 2,
        optDateBegin: null,
        optDateEnd: null,
        loading: false,
        setLoading: false,
        exportData: [],
        setExportData: [],
        DataSet: [],
        month: moment()
          .startOf("month")
          .format("YYYYMMDD")
      };
    }

    
  
    async componentDidMount() {
        moment_tz.tz.setDefault("Europe/Madrid");

        const startDate = moment()
            // .startOf("year")
            .format("YYYYMMDD");

        const endDate = moment()
            // .startOf("year")
            // .add(2, "month")
            .format("YYYYMMDD");

        await this.updateState(startDate, endDate, null, null, null);
      
    }
  
    updateState = async (
      startDate,
      endDate,
      optDateBegin,
      optDateEnd
    ) => {  
      const numberOfMonths = moment(endDate).diff(moment(startDate), "months");
  
      this.setState({
        numberOfMonths,
        isLoading: false,
        startDate,
        endDate,
        month: moment(startDate)
        //   .startOf("month")
          .format("YYYYMMDD"),
        optDateBegin,
        optDateEnd
      });
    };
  
    sortedDayList = (start, end) => {
      const add = (day, offset) => day.clone().add(offset, "days");
      return map(curry(add)(start), range(0, end.diff(start, "days") + 1));
    };
  
    handleChangeOptE = eventDate => {
      this.setState({ optDateEnd: moment(eventDate) });
    };
  
    handleChangeOptB = eventDate => {
      this.setState({
        optDateBegin: eventDate
      });
  
      if (!isNil(eventDate) && isNil(this.state.optDateEnd)) {
        const newDate = moment(eventDate.format("YYYY-MM-DD")).add(1, "day");
        this.setState({
          optDateEnd: newDate
        });
      } else if (!isNil(this.state.optDateBegin) && !isNil(eventDate)) {
        if (moment(eventDate).isSameOrAfter(moment(this.state.optDateEnd))) {
          const newDate = moment(eventDate.format("YYYY-MM-DD")).add(1, "day");
          this.setState({
            optDateEnd: newDate
          });
        }
      }
    };

    handleChange = () => {
        dataSet1 = [];
        if(this.state.optDateBegin !== null && this.state.optDateEnd !== null &&
          this.state.optDateBegin !== '' && this.state.optDateEnd !== '') {
            this.setState({ exportData: [], loading: true });
            this.getCharges(this.state.optDateBegin.format("YYYY-MM-DD"), this.state.optDateEnd.format("YYYY-MM-DD"));
        }
      };

    async getCharges(startDate, endDate, location) {
        
        const dataProvider = await dataProviderFactory("rest");
        const chargesReport = dataProvider(GET_LIST, "charges/report", {
        filter: {
            startDate: this.state.optDateBegin.format("YYYY-MM-DD"),
            endDate: this.state.optDateEnd.format("YYYY-MM-DD")
        },

        pagination: {
            page: 1,
            perPage: 99999
        },
        sort: { field: this.props.created_at, order: "DESC" }
        });

        chargesReport.then((result) => {
            this.state.loading = false;
            dataSet1 = result.data;
            const dataSet = [{
                columns: [               
                    {title: "Firstname", style: {font: {sz: "14", bold: true}, fill: {patternType: "solid", fgColor: {rgb: "C0C0C0"}}}, width: {wpx: 125}}, // width in pixels
                    {title: "Lastname", style: {font: {sz: "14", bold: true}, fill: {patternType: "solid", fgColor: {rgb: "C0C0C0"}}}, width: {wpx: 125}}, // width in characters
                    {title: "Value", style: {font: {sz: "14", bold: true}, fill: {patternType: "solid", fgColor: {rgb: "C0C0C0"}}}, width: {wpx: 125}}, // width in pixels
                    {title: "Date", style: {font: {sz: "14", bold: true}, fill: {patternType: "solid", fgColor: {rgb: "C0C0C0"}}}, width: {wpx: 125}}, // width in pixels
                    {title: "Comments", style: {font: {sz: "14", bold: true}, fill: {patternType: "solid", fgColor: {rgb: "C0C0C0"}}}, width: {wpx: 200}}, // width in pixels                    
                ],
                data: result.data.map((data) => [
                    {value: (data.client_first_name != null) ? data.client_first_name : '', style: {font: {sz: "12"}}},
                    {value: (data.client_last_name != null) ? data.client_last_name : '', style: {font: {sz: "12"}}},
                    {value: (data.valueCharges != null) ? data.valueCharges : '', style: {font: {sz: "12"}}},
                    {value: (data.dateCharges != null) ? moment(data.dateCharges).format("DD/MM/YYYY") : '', style: {font: {sz: "12"}}},
                    {value: (data.commentsCharges != null) ? data.commentsCharges : '', style: {font: {sz: "12"}}},

                    
                ])
            }];
            
            this.setState({ loading: false, exportData: result.data, DataSet: dataSet });
            return result.data;
        })
        .catch((error) => {
            this.state.loading = false;
        });        
    }
  
    render() {
      const {
        isLoading,
        month,
        optDateBegin,
        optDateEnd,
        numberOfMonths
      } = this.state;

      const { classes, ...props } = this.props;

      
  
      if (isLoading) {
        return (
          <Card>
            <LinearProgress />
          </Card>
        );
      }
  
      const startDate = month;
      const endDate = moment(month)
        // .add(numberOfMonths, "months")
        .format("YYYYMMDD");

        const PostCreateToolbar = props => <Toolbar {...props} style={{ backgroundColor: 'transparent' }}>
            <SaveButton label="Generate" onClick={this.handleChange}/>
            {this.state.exportData.length !== 0 ? (
                    <ExcelFile filename="Charges" 
                      element={<SaveButton label="Download" style={{ marginLeft: '10px' }}/>}>
                      <ExcelSheet dataSet={this.state.DataSet} name="Charges"/>
                    </ExcelFile>
                      // <ExcelFile filename="Charges" 
                      //   element={<SaveButton label="Download" style={{ marginLeft: '10px' }}/>} id="excelFile">
                      //   <ExcelSheet data={dataSet1} name="Charges">
                      //     <ExcelColumn label="Firstname" value="client_first_name"/>
                      //     <ExcelColumn label="Lastname" value="client_last_name"/>
                      //     <ExcelColumn label="Value" value="valueCharges"/>
                      //     <ExcelColumn label="Date" value='dateCharges'/>
                      //     <ExcelColumn label="Comments" value='commentsCharges'/>
                      //   </ExcelSheet>
                      // </ExcelFile>
                    ): null}    
        </Toolbar>;
  
      return (
        <Card>
            <StartForm>
                <h3>Reports</h3>
                <FormControl>
                <CustomDatePicker
                    onChange={e => this.handleChangeOptB(e)}
                    selectedDate={
                    optDateBegin && optDateBegin !== "null"
                        ? moment(optDateBegin).format("YYYY-MM-DD")
                        : null
                    }
                    label="Date Begin"
                    // minDate={moment(startDate)}
                    // maxDate={moment(endDate).format("YYYY-MM-DD")}
                />
                </FormControl>
                <FormControl>
                <CustomDatePicker
                    onChange={e => this.handleChangeOptE(e)}
                    selectedDate={
                    optDateEnd && optDateEnd !== "null"
                        ? moment(optDateEnd).format("YYYY-MM-DD")
                        : null
                    }
                    label="Date End"
                    // minDate={moment(optDateBegin).add(1, "day")}
                    // maxDate={moment(endDate).format("YYYY-MM-DD")}
                />
                </FormControl>                 
                <PostCreateToolbar />
            </StartForm>
            <Table>
              <TableHead>
                <TableRow>                
                  <TableCell style={styles.rightAlignedCell}>Firstname</TableCell>
                  <TableCell style={styles.rightAlignedCell}>Lastname</TableCell>
                  <StyledTableCell style={styles.rightAlignedCell}>
                    Value
                  </StyledTableCell>
                  <TableCell style={styles.leftAlignedCell}>
                    Date
                  </TableCell>
                  <TableCell style={styles.leftAlignedCell}>
                  Comments
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              
              {this.state.exportData.length === 0 ? (
                this.state.loading ? (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <LinearProgress />
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} style={styles.container}>
                      No hay Resultados...
                    </TableCell>
                  </TableRow>
                )
              ) : null}
              {dataSet1.map((item) => (
                <TableRow key={item.chargeID}>
                  <TableCell style={styles.leftAlignedCell}>
                    {item.client_first_name}
                  </TableCell>
                  <TableCell style={styles.leftAlignedCell}>
                    {item.client_last_name}
                  </TableCell>
                  <TableCell style={styles.rightAlignedCell}>
                    {(item.valueCharges).toLocaleString(
                      undefined,
                      {
                        style: "currency",
                        currency: "EUR",
                      }
                    )}
                  </TableCell>
                  <StyledTableCell style={styles.rightAlignedCell}>
                    {moment(item.dateCharges).format("DD/MM/YYYY")}
                  </StyledTableCell>
                  <TableCell style={styles.rightAlignedCell}>
                    {item.commentsCharges}
                  </TableCell>
                </TableRow>
              ))}
              </TableBody>
            </Table>
        </Card>
      );
    }
  }

  export default ReportDetails;


// WEBPACK FOOTER //
// ./src/components/reportDetails.js